import { STATUS, EMPTY_STRING } from '@constants/common';
import { RESET_CRUD_NOTIFICATION, NOTIFICATION_UPDATE, TABLE_STATE } from '@constants/actions';
import { INotificationUpdate, IActionNotification } from '@interfaces/common.interface';
import createAction from './actionCreator';

export const resetNotification = (serviceType = EMPTY_STRING, operationType = EMPTY_STRING) => {
  return createAction(RESET_CRUD_NOTIFICATION, { serviceType, operationType });
};

export const changeTableState = (service: string, state) => {
  return async function (dispatch: any) {
    dispatch(createAction(TABLE_STATE.CHANGE, { service, state }));
  };
};

export const resetTableState = (service: string) => {
  return async function (dispatch: any) {
    dispatch(createAction(TABLE_STATE.RESET, { service }));
  };
};

export const operationInProgress = (serviceType: string, operationType: string ) => {
  const notificationUpdate: INotificationUpdate = {
    serviceType,
    operationType,
    notification: new IActionNotification(STATUS.IN_PROGRESS)
  };
  return createAction(NOTIFICATION_UPDATE, notificationUpdate);
};

export const operationSuccess = (message: string, serviceType: string, operationType: string) => {
  const notificationUpdate: INotificationUpdate = {
    serviceType,
    operationType,
    notification: new IActionNotification(STATUS.SUCCESS, message, true)
  };
  return createAction(NOTIFICATION_UPDATE, notificationUpdate);
};

export const operationFail = (message: string, serviceType: string, operationType: string) => {
  const notificationUpdate: INotificationUpdate = {
    serviceType,
    operationType,
    notification: new IActionNotification(STATUS.FAILED, message, false)
  };
  return createAction(NOTIFICATION_UPDATE, notificationUpdate);
};